import { tupleToStringKey } from 'js/lib/stringKeyTuple';
import { get as getUser } from 'js/lib/user';

import { useNaptime } from 'bundles/naptimejs';
import OnDemandWidgetSessionsV1 from 'bundles/naptimejs/resources/onDemandWidgetSessionsV1';
import type { WidgetSession } from 'bundles/widget/types/WidgetSession';

export type UseWidgetSessionResult = { session: WidgetSession; sessionId: string };

const useWidgetSession = (courseId: string, itemId: string, skip?: boolean): UseWidgetSessionResult | null => {
  const userId = getUser().id;
  const id = tupleToStringKey([userId.toString(), courseId, itemId]);

  const naptimeResponse = useNaptime<{ widgetSession: UseWidgetSessionResult }>(() => {
    if (skip) {
      return {};
    }

    return {
      widgetSession: OnDemandWidgetSessionsV1.get(id, {
        fields: ['session', 'sessionId'],
      }),
    };
  }, [id]);

  return naptimeResponse.data.widgetSession;
};

export default useWidgetSession;
